<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.currentSearch}}</h3>
</div>
<div class="modal-body">
    <div *ngIf="searchHistory && searchHistory.length > 0" class="search-terms">
        <div *ngFor='let search of searchHistory'>
            <div class="row" style="margin:0px">
                <div class="truncate text-left">
                	<div><span class="sub-label lb-md">{{LOCALIZATION.query}}</span></div>
                    <div class="table-container"><span class="sub-label table-cell">{{LOCALIZATION.queryTerms}} </span><span class="text table-cell">{{search.qs}}</span></div>
	                <div class="table-container"><span class="sub-label table-cell">{{LOCALIZATION.type}} </span><span class="text table-cell">{{search.type}}</span></div>
	                <div class="table-container"><span class="sub-label table-cell">{{LOCALIZATION.totalResults}} </span><span class="text table-cell">{{search.total}}</span></div>
	                <div class="help-block">
	                	<span style="font-style: italic;">For help with your search, see <a (click)="displayHelp()" class="pointMe">search tips</a>.</span>
	                </div>
	                <div [hidden]="!search.criteria || search.criteria.length == 0" style="margin-top: 16px;">
	                	<span class="sub-label lb-md">{{LOCALIZATION.searchCriteria}}</span>
	                </div>
	                <div>
	                    <div *ngFor="let c of search.criteria" class="table-container truncate" style="margin-top: 4px;">
	                        <span class="sub-label table-cell">{{c.label}}</span><span class="text table-cell truncate" style="font-size:12px" title="{{c.value}}">{{c.value}}</span>
	                    </div>
	                </div>               
	                <div [hidden]="concepts.length == 0" style="margin-top: 16px;">
	                	<span class="sub-label lb-md">{{LOCALIZATION.expansions}}</span>
	                	<div class="help-block">{{LOCALIZATION.conceptQueryTermsExplainer}}</div>
	                </div>
		            <div style="columns:4; margin-top:4px;">
	   					<div *ngFor="let c of concepts" class="truncate">
	       					<span title="{{c}}">{{c}}</span>
	   					</div>
					</div>
                </div>
            </div>
        </div>
    </div>	
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>